// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'

/* axios */
import axios from './api'
import api from './api/api'
Vue.prototype.http = axios;
Vue.prototype.api = api;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'

/* 全站统一的点击 / 聚焦反馈：
   覆盖浏览器默认的琥珀色 1px 线框与 Bootstrap 5 的蓝色聚焦光晕，改为品牌玫红细环 + 按压下沉。
   必须放在所有全局样式之后，确保优先级最高。 */
import './assets/css/focus.css'


/* 头部组件 */
// import Header from './components/Header'
import HeaderNew from './components/HeaderNew'
// Vue.component(Header.name,Header)
Vue.component(HeaderNew.name,HeaderNew)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false


/* ============ SEO：页面级 meta 动态注入 ============ */
/* 各页面可在 router/index.js 的 meta 中配置 title / description / keywords，
   未配置的页面回退到下方站点级默认值（与 index.html 保持一致）。 */
const DEFAULT_DESCRIPTION = '海南华德科技有限公司聚焦医疗健康、电子政务、数字企业三大核心领域，在医疗设备管理、互联网医院、传染病预警、智慧病房、政务信息化与数字企业转型等方面拥有多省份落地案例，为客户提供覆盖全业务链条的数字化解决方案，深受行业客户认可。'
const DEFAULT_KEYWORDS = '医疗健康,电子政务,数字企业,互联网医院,医疗设备管理,海南华德科技有限公司'
/* 生产环境站点域名（固定写死，避免预渲染时本地静态服务器 localhost 污染 canonical/og:url） */
const SITE_DOMAIN = 'https://www.hiwald.com'

/**
 * 设置（或更新）一个 meta 标签
 * @param {string} attrName  定位用的属性名，如 name / property
 * @param {string} attrValue 定位用的属性值，如 description / og:title
 * @param {string} content   要写入的内容
 */
const setMetaTag = (attrName, attrValue, content) => {
  if (!content) return
  let el = document.head.querySelector('meta[' + attrName + '="' + attrValue + '"]')
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attrName, attrValue)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

/* canonical：避免同一页面因 query 参数被判为重复内容 */
const setCanonical = (url) => {
  let el = document.head.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', url)
}

router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});

router.afterEach((to) => {
  const description = to.meta.description || DEFAULT_DESCRIPTION
  const keywords = to.meta.keywords || DEFAULT_KEYWORDS

  setMetaTag('name', 'description', description)
  setMetaTag('name', 'keywords', keywords)
  setMetaTag('property', 'og:title', document.title)
  setMetaTag('property', 'og:description', description)
  setMetaTag('property', 'og:url', SITE_DOMAIN + to.fullPath.split('?')[0])
  setCanonical(SITE_DOMAIN + to.fullPath.split('?')[0])
});


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js